import { defineNuxtPlugin, useState } from "#imports";
import { getBreadcrumbFromRouteQuery } from "#vuepal/helpers/breadcrumb";
export default defineNuxtPlugin({
  name: "vuepal:breadcrumb",
  setup(app) {
    const state = useState("breadcrumbLinks", () => []);
    app.hooks.hook("vuepal:drupal-route", (data) => {
      state.value = getBreadcrumbFromRouteQuery(data.routeQuery);
    });
  }
});
